import React, {useContext, useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {Button, Divider, message, Modal, Select, TreeSelect} from "antd"
import {QuestionCircleOutlined} from "@ant-design/icons"
import UserContext from "../../context/UserContext"
import {getListExtensions, updateUser} from "../../../../services/api/apiUser"
import parseToken from "../../../../helpers/parseToken"
import SelectSearchDouble from "../actions/SelectSearchDouble"
import {generatePasswordRandom} from "../../../../helpers/generatePassword"

UserForm.propTypes = {
    type: PropTypes.any,
    item: PropTypes.any
}

function UserForm(props) {
    const decodeToken = parseToken()
    const {type, label, item, showEdit, onHiddenEdit} = props
    const {
        treeData,
        getUsers,
        listDepartment,
        roles,
        tenants,
        getExtensions,
        listCalloutId
    } = useContext(UserContext)

    const [loading, setLoading] = useState(false)
    const [fullName, setFullName] = useState(item.fullName)
    const [deptId, setDeptId] = useState(item.deptId)
    const [deptName, setDepName] = useState(item.deptName)
    const [status, setStatus] = useState(item.status)
    const [roleId, setRoleId] = useState(!!item.roles && item.roles.length > 0 ? item.roles.map(item => item.roleId) : [])
    const [tenantId, setTenantId] = useState(item.tenantId || (tenants[0].id))
    const [extension, setExtension] = useState(item.extension || 0)
    const [calloutId, setCalloutId] = useState(item.calloutId || '')
    const [email, setEmail] = useState(item.email || '')
    const [cellPhone, setCellPhone] = useState(item.phone || '')
    const [password, setPassword] = useState(item.password || '')
    const [validate, setValidate] = useState({})
    const [listExtensions, setListExtensions] = useState([])

    const _handleChange = (value) => {
        setDeptId(value)

        const deptSelected = listDepartment.filter(item => item.deptId === value)
        setDepName(deptSelected[0].deptName)
        delete validate['deptName']
    }

    const _onGeneratePassword = () => {
        setPassword(generatePasswordRandom(6))
    }

    const _handleChangeRoleId = (value) => {
        setRoleId(value)
        delete validate['roleIdList']
    }

    const _handleChangeEmail = (e) => {
        const {value} = e.target

        setEmail(value)
        delete validate['email']
    }

    const _handleChangePassword = (e) => {
        const {value} = e.target
        setPassword(value)
        delete validate['password']
    }

    const _handleChangePhone = (e) => {
        const {value} = e.target

        setCellPhone(value)
        delete validate['phone']
    }

    const _handleChangeName = (e) => {
        const {value} = e.target

        setFullName(value)
        delete validate['fullName']
    }

    const _handleChangeStatus = (value) => {
        setStatus(value)
    }

    const _handleChangeTenants = (value) => {
        setTenantId(value)
        setExtension('')
        delete validate['tenantId']
    }

    const _handleChangeExtension = (value) => {
        setExtension(value)
        delete validate['extension']
    }

    const _handleChangeCallout = (name, value) => {
        setCalloutId(value)
    }

    const _onUpdateUser = async () => {
        setLoading(true)

        const validateCheck = _validateData()

        if (Object.keys(validateCheck).length > 0) {
            setLoading(false)
            return false
        }

        try {
            const payload = {
                userId: item.userId,
                userName: item.userName,
                fullName,
                roleId: roleId,
                deptId,
                deptName,
                status,
                tenantId,
                extension,
                cellPhone,
                email: email || 'alogiare.com@gmail.com',
                calloutId,
                password
            }
            const response = await updateUser(payload, decodeToken.sub)

            const {success} = response

            if (success !== '1') {
                setLoading(false)

                return message.error("Cập nhật không thành công.")
            }

            setLoading(false)
            message.success("Cập nhật thành công.")
            handleCancel()
            getExtensions()
            getUsers()
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const _validateData = () => {
        let validateForm = {}
        const regexPhone = /^[0-9]\d*$/

        if (email) {
            if (!(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email))) {
                Object.assign(validateForm, {email: 'Email phải đúng định dạng'})
            }
        }

        if (cellPhone !== '' && (!regexPhone.test(cellPhone) || (cellPhone.indexOf('0') === 0 && cellPhone.length !== 10) || (cellPhone.indexOf('0') !== 0 && cellPhone.length !== 9))) {
            Object.assign(validateForm, {phone: 'Số điện thoại không đúng định dạng.'})
        }

        if (!!password && password.length < 6) {
            Object.assign(validateForm, {password: 'Password là bắt buộc và lớn hơn 6 ký tự'})
        }

        if (tenantId === undefined || tenantId === '') {
            Object.assign(validateForm, {tenantId: 'Công ty là bắt buộc'})
        }

        if (deptName === undefined || deptName === '') {
            Object.assign(validateForm, {deptName: 'Phòng ban là bắt buộc'})
        }

        if (roleId === undefined || roleId === '') {
            Object.assign(validateForm, {roleIdList: 'Danh sách quyền là bắt buộc'})
        }

        if (extension === undefined || extension === '') {
            Object.assign(validateForm, {extension: 'Số mở rộng là bắt buộc'})
        }

        setValidate(validateForm)

        return validateForm
    }

    const _getExtensions = async () => {
        try {
            const response = await getListExtensions({tenantId: tenantId}, decodeToken.sub)
            const {success, data} = response
            if (parseInt(success) !== 1) {
                return
            }
            const _extensions = data.map(itemM => {
                return {
                    name: itemM.extension,
                    value: itemM.extension,
                    status: itemM.status
                }
            })
            setListExtensions([..._extensions])
        } catch (e) {

        }
    }

    const onSave = async () => {
        await _onUpdateUser()
    }

    const handleCancel = () => {
        onHiddenEdit()
        _resetCustomerInfo()
    }

    const onSaveAndNew = async () => {
        alert('Chức năng đang được phát triển.')
    }

    const handleOk = async () => {
        Modal.confirm({
            title: 'Confirm',
            icon: <QuestionCircleOutlined/>,
            content: 'Bạn chắc chắn muốn lưu user này?',
            okText: 'Save',
            cancelText: 'Cancel',
            onOk: onSave
        })
    }

    const handleOkAndNew = async () => {
        Modal.confirm({
            title: 'Confirm',
            icon: <QuestionCircleOutlined/>,
            content: 'Bạn chắc chắn muốn lưu và tạo mới user?',
            okText: 'Save',
            cancelText: 'Cancel',
            onOk: onSaveAndNew
        })
    }

    const confirmCancel = () => {
        Modal.confirm({
            title: 'Confirm',
            icon: <QuestionCircleOutlined/>,
            content: 'Bạn chắc chắn muốn thoát?',
            okText: 'Yes',
            cancelText: 'Cancel',
            onOk: handleCancel
        })
    }

    const _resetCustomerInfo = () => {
        setFullName(item.fullName)
        setDeptId(item.deptId)
        setDepName(item.deptName)
        setStatus(item.status)
        setRoleId(item.roleId)
        setTenantId(item.tenantId)
        setExtension(item.extension)
        setCalloutId(item.calloutId)
        setEmail(item.email)
        setCellPhone(item.cellPhone)
        setPassword(item.password)
    }

    useEffect(() => {
        _getExtensions()
        // eslint-disable-next-line
    }, [tenantId])

    useEffect(() => {
        setFullName(item.fullName)
        setDeptId(item.deptId)
        setDepName(item.deptName)
        setStatus(item.status)
        setRoleId(!!item.roles && item.roles.length > 0 ? item.roles.map(item => item.roleId) : [])
        setTenantId(item.tenantId)
        setExtension(item.extension)
        setCalloutId(item.calloutId)
        setEmail(item.email)
        setCellPhone(item.cellPhone)
        setPassword(item.password)
        // eslint-disable-next-line
    }, [item])

    return (
        <div className="CustomerForm">
            <Modal
                title={label}
                className="ModalCustom"
                centered
                visible={showEdit}
                onOk={handleOk}
                onCancel={confirmCancel}
                footer={[
                    <Button key="back" onClick={confirmCancel}>
                        Cancel
                    </Button>,
                    <Button className={`${type}`} key="submit2" type="primary" loading={loading}
                            onClick={handleOkAndNew}>
                        Save & New
                    </Button>,
                    <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
                        Save
                    </Button>
                ]}
            >
                <div className="FormEdit">
                    <Divider orientation="left" orientationMargin="0">Thông tin tin chung</Divider>
                    <div className="row">
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="name">
                                Username
                            </label>
                            <input type="text" className="InputDisable" value={item.userName} disabled/>
                        </div>
                        <div className={`FieldItem ${validate.password && 'error'} col-md-6`}>
                            <label className="Label" htmlFor="password">
                                Mật khẩu
                                <span className="Required">*</span>
                            </label>
                            <div className="generate-password">
                                <input
                                    id="password"
                                    type={'text'}
                                    value={password || ''}
                                    placeholder='********'
                                    onChange={_handleChangePassword}
                                />
                                <Button type="primary" onClick={_onGeneratePassword}>Generate</Button>
                            </div>
                            {
                                validate.password && <span className="Error text-danger">{validate.password}</span>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="name">
                                Tên người dùng
                                <span className="Required">*</span>
                            </label>
                            <input type="text" value={fullName} onChange={_handleChangeName}/>
                            {
                                validate.fullName && <span className="Error text-danger">{validate.fullName}</span>
                            }
                        </div>
                        <div className={`FormField ${validate.email && 'error'} col-md-6`}>
                            <label className="Label" htmlFor="email">
                                Email
                            </label>
                            <input id="email" name="email" type="text" value={email || ''}
                                   onChange={_handleChangeEmail}/>
                            {
                                validate.email && <span className="Error text-danger">{validate.email}</span>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="tenants">
                                Công ty
                                <span className="Required">*</span>
                            </label>
                            <Select
                                showSearch
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                optionFilterProp="children"
                                onChange={_handleChangeTenants}
                                value={tenantId || ''}
                            >
                                {!!tenants && tenants.length > 0 && tenants.map((item) => (
                                    <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                                ))}
                            </Select>
                            {
                                validate.tenantId && <span className="Error text-danger">{validate.tenantId}</span>
                            }
                        </div>
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="name">
                                Phòng ban
                                <span className="Required">*</span>
                            </label>
                            <TreeSelect
                                style={{width: '100%'}}
                                value={deptId || ''}
                                dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                                treeData={treeData}
                                placeholder="Please select"
                                treeDefaultExpandAll
                                onChange={_handleChange}
                                showSearch
                                filterTreeNode={(search, item) => {
                                    return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
                                }}
                            />
                            {
                                validate.deptName && <span className="Error text-danger">{validate.deptName}</span>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="name">
                                Trạng thái
                            </label>
                            <Select value={status} onChange={_handleChangeStatus}>
                                <Select.Option value={1}>Active</Select.Option>
                                <Select.Option value={0}>Disable</Select.Option>
                            </Select>
                        </div>
                        <div className={`FormField ${validate.phone && 'error'} col-md-6`}>
                            <label className="Label" htmlFor="phone">
                                Phone
                            </label>
                            <input id="phone" type="text" value={cellPhone || ''} onChange={_handleChangePhone}/>
                            {
                                validate.phone && <span className="Error text-danger">{validate.phone}</span>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className={`FieldItem ${validate.roleIdList && 'error'} col-md-12`}>
                            <label className="Label" htmlFor="name">
                                Danh sách quyền
                                <span className="Required">*</span>
                            </label>
                            <Select
                                showSearch
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                optionFilterProp="children"
                                className="SelectMulti"
                                mode="multiple"
                                allowClear
                                style={{width: '100%'}}
                                placeholder="Please select"
                                value={roleId}
                                onChange={_handleChangeRoleId}
                            >
                                {
                                    !!roles && roles.length > 0 && roles.map(item => {
                                        return <Select.Option key={item.roleId}
                                                              value={item.roleId}>{item.roleName}</Select.Option>
                                    })
                                }
                            </Select>
                            {
                                validate.roleIdList && <span className="Error text-danger">{validate.roleIdList}</span>
                            }
                        </div>
                    </div>
                    <Divider orientation="left" orientationMargin="0">Tùy chọn cấu hình tổng đài</Divider>
                    <div className="row">
                        <div className="FormField col-md-6">
                            <label className="Label" htmlFor="extension">
                                Gán số extension
                                <span className="Required">*</span>
                            </label>
                            <Select
                                onChange={_handleChangeExtension}
                                placeholder="Please select"
                                value={extension}
                                showSearch
                            >
                                <Select.Option value={0}>--Chọn--</Select.Option>
                                {!!listExtensions && listExtensions.length > 0 && listExtensions.map((item) => (
                                    <Select.Option key={item.value} value={item.value} disabled={item.status === 1}>
                                        {item.name}
                                    </Select.Option>
                                ))}
                            </Select>
                            {
                                validate.extension && <span className="Error text-danger">{validate.extension}</span>
                            }
                        </div>
                        <div className="FieldItem col-md-6">
                            <SelectSearchDouble
                                name="calloutId"
                                value={calloutId}
                                onChange={_handleChangeCallout}
                                label="Nhóm gọi ra"
                                listSelect={listCalloutId}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default UserForm
